import { createFileRoute, redirect } from "@tanstack/react-router";

import { DoneStep } from "~/pages/onboard/steps/done-step";
import { activeOrganization$ } from "~/stores/organizations";

/**
 * Final celebration screen. Reached from the boards step (or its
 * no-datasource fallback) once the user has finished setup — the trial/plan
 * step was removed, so new orgs land here on the implicit free plan. The
 * step component flips `org.onboarding` to `"done"` when the user clicks
 * "Continue to Mora".
 *
 * Accepts `"boards"` (no-datasource fallback lands here while the column is
 * still `"boards"`), `"plan"` (transitional marker after boards are picked),
 * and `"done"` (a refresh after Continue, racing the layout observer's
 * redirect to `/`).
 */
export const Route = createFileRoute("/onboard/done")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "done") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const org = activeOrganization$.get();
    if (!org?.id) {
      throw redirect({ to: "/onboard", replace: true });
    }
    if (
      org.onboarding !== "boards" &&
      org.onboarding !== "plan" &&
      org.onboarding !== "done"
    ) {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: DoneStep,
});
